import React from "react";
import ct from "class-types.macro";
import { ConfigurationOption } from "../ProductDetailPageResult";
import { VirtualGroupingVariation } from "./VirtualGroupingModel";
import { findSelectedOption } from "./VirtualGroupingHelper";
import { baseTileButtonStyling, selectedTileButtonBorderStyling, baseBorderStyling, baseHoverStyling } from "./VirtualGroupingTiles.styles";
interface GroupConfigurationTileProps {
  virtualGroupTileVariations: readonly VirtualGroupingVariation[];
  selectedOptions: readonly ConfigurationOption[];
  getValidOptions: string[];
  onButtonHoverEnter: (name: string, e: React.MouseEvent<HTMLButtonElement>) => void;
  onButtonHoverLeave: () => void;
  onlyFocusOnKeyboardEvent: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  onClickPosition: () => void;
  handleClickVirtualGroupingVariation: (name: string, value: string, validOption: boolean) => void;
}
const GroupConfigurationTile = ({
  virtualGroupTileVariations,
  selectedOptions,
  onButtonHoverEnter,
  onButtonHoverLeave,
  onlyFocusOnKeyboardEvent,
  getValidOptions,
  onClickPosition,
  handleClickVirtualGroupingVariation
}: GroupConfigurationTileProps) => {
  return <>
      {virtualGroupTileVariations.map((variation, index) => <button key={variation.value} aria-pressed={findSelectedOption(variation, selectedOptions) ? "true" : "false"} data-testid={`variationOption-${index}`} className={`${baseTileButtonStyling} ${!variation.isInStock && !findSelectedOption(variation, selectedOptions) ? "before:hover:border-solid before:border-dashed" : "before:border-solid"} ${findSelectedOption(variation, selectedOptions) ? selectedTileButtonBorderStyling : baseBorderStyling} ${baseHoverStyling}`} type="button" value={variation.value} onClick={e => {
      handleClickVirtualGroupingVariation(variation.name, e.currentTarget.value, getValidOptions.includes(e.currentTarget.value));
      onClickPosition();
    }} onMouseEnter={e => onButtonHoverEnter(variation.name, e)} onMouseLeave={onButtonHoverLeave} onKeyUp={e => onlyFocusOnKeyboardEvent(e)}>
          <div className={ct("flex", "flex-col", "items-center", "box-border")}>
            {variation.name === "Color" ? <div className={ct("w-16", "h-16", "relative")}>
                {!variation.isInStock && <span className={ct("absolute", "border", "border-solid", "border-gray-600", "top-1/2", "shadow", "inset-x-0")} style={{
            transform: "rotate(-55deg)",
            zIndex: 1,
            boxShadow: "0px -1px 0px #FFFFFF, 0px 1px 0px #FFFFFF"
          }} />}
                <img src={variation.previewImage} alt={variation.value} className={`${ct("w-full", "mix-blend-multiply")} ${!variation.isInStock ? ct("opacity-50") : ""}`} />
              </div> : <div className={ct("flex", "h-full", "items-center")}>
                <p className={ct("mb-0", "text-sm", "leading-4", "font-semibold", !variation.isInStock ? "text-gray-700" : "text-gray-800", "hover:text-gray-800")}>
                  {variation.value}
                </p>
                {!variation.isInStock && <span className={ct("sr-only")}>is out of stock</span>}
              </div>}
          </div>
        </button>)}
    </>;
};
export default GroupConfigurationTile;